module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatter"
  }, [_c('div', {
    staticClass: "title-frontMatter"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781466821378_toc01#toctitle148",
      "id": "title148"
    }
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Players in the Queen’s Game")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-c"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("(Names in italics are of people who died before the tale of")]), _vm._v(" Wisdom’s Daughter "), _c('em', {
    staticClass: "i"
  }, [_vm._v("begins.)")])])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title149"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("IN SHEBA")])]), _vm._v(" "), _c('div', {
    staticClass: "p-br"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Allit,")]), _vm._v(" Queen Bilqis’s daughter "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("Baalit, Allit’s")]), _vm._v(" daughter "), _c('br'), _vm._v("Bilqis, Queen of Sheba "), _c('br'), _vm._v("Boaz, an emissary from King Solomon’s court "), _c('br'), _vm._v("Hawlyat, head of the Sheban Cloth Traders’ Guild "), _c('br'), _vm._v("Hodaiah, captain of King Solomon’s merchant fleet "), _c('br'), _vm._v("Irsiya, Queen Bilqis’s handmaiden "), _c('br'), _vm._v("Jotham, King Solomon’s brother and his emissary to Sheba "), _c('br'), _vm._v("Khurrami, Queen Bilqis’s handmaiden "), _c('br'), _vm._v("Mubalilat, Queen Bilqis’s vizier "), _c('br'), _vm._v("Nikaulis, Amazon captain of the queen’s guard "), _c('br'), _vm._v("Rahbarin, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Sahjahira’s")]), _vm._v(" son "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("Sahjahira,")]), _vm._v(" Queen Bilqis’s younger half-sister "), _c('br'), _vm._v("Shakarib, master of the court, Queen Bilqis’s chief steward "), _c('br'), _vm._v("Tamrin, the chief eunuch, Irsiya’s brother "), _c('br'), _vm._v("Uhhayat, the royal chamberlain")])])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title150"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("IN JERUSALEM")])]), _vm._v(" "), _c('div', {
    staticClass: "p-br"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Abiathar,")]), _vm._v(" high priest during "), _c('em', {
    staticClass: "i"
  }, [_vm._v("King David’s")]), _vm._v(" reign "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("Abishag,")]), _vm._v(" King Solomon’s first wife and first love, Princess Baalit’s mother "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("Absalom,")]), _vm._v(" Solomon’s older half-brother "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("Adonijah,")]), _vm._v(" Solomon’s older half-brother "), _c('br'), _vm._v("Ahijah, the new great prophet "), _c('br'), _vm._v("Ahishar, the palace steward "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("Amnon,")]), _vm._v(" Solomon’s older half-brother\n"), _c('br'), _vm._v("Amyntor, a visitor from Caphtor "), _c('br'), _vm._v("Athaniel, Ishvaalit’s brother "), _c('br'), _vm._v("Baalit, daughter of King Solomon and "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Queen Abishag")]), _vm._v(" "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("Bathsheba,")]), _vm._v(" King Solomon’s mother "), _c('br'), _vm._v("Benaiah, the king’s general, commander of the army "), _c('br'), _vm._v("Chadara, overseer of the women’s palace "), _c('br'), _vm._v("Citrajoyti, King Solomon’s wife from India "), _c('br'), _vm._v("Dacxuri, King Solomon’s wife from Colchis "), _c('br'), _vm._v("Dathan, servant of Elihoreph, the scribe "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("David, King of Israel and Judah,")]), _vm._v(" King Solomon’s father "), _c('br'), _vm._v("David, King Solomon and Queen Makeda’s son "), _c('br'), _vm._v("Dvorah, one of King Solomon’s Hebrew wives "), _c('br'), _vm._v("Elihoreph, the chief scribe "), _c('br'), _vm._v("Gamaliel, head groom of King Solomon’s horse farm "), _c('br'), _vm._v("Gilade, one of King Solomon’s concubines "), _c('br'), _vm._v("Helike, King Solomon’s wife from Troy "), _c('br'), _vm._v("Ishvaalit, Princess Baalit’s friend "), _c('br'), _vm._v("Jeroboam, superintendent of the Forced Levy "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("Joab, King David’s")]), _vm._v(" war-chief "), _c('br'), _vm._v("Keshet, Princess Baalit’s handmaiden "), _c('br'), _vm._v("Lahad, Prince Rehoboam’s friend "), _c('br'), _vm._v("Leeorenda, one of King Solomon’s concubines "), _c('br'), _vm._v("Makeda, King Solomon’s wife from Cush "), _c('br'), _vm._v("Melasadne, King Solomon’s wife from Melite "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("Michal, King David’s")]), _vm._v(" queen, King Solomon’s foster-mother "), _c('br'), _vm._v("Miri, a palace slave "), _c('br'), _vm._v("Naamah, King Solomon’s wife from Ammon, Prince Rehoboam’s mother "), _c('br'), _vm._v("Nefret-meryt-hotep, King Solomon’s wife from Egypt "), _c('br'), _vm._v("Nimrah, Princess Baalit’s handmaiden "), _c('br'), _vm._v("Oreb, Prince Rehoboam’s friend "), _c('br'), _vm._v("Pelaliah, Prince Rehoboam’s friend "), _c('br'), _vm._v("Rehoboam, King Solomon and Queen Naamah’s son, the crown prince "), _c('br'), _vm._v("Reuben, a stable boy "), _c('br'), _vm._v("Rivkah, Princess Baalit’s maid, once "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Queen Abishag’s")]), _vm._v(" servant "), _c('br'), _vm._v("Ruth, one of King Solomon’s minor wives, once known as Surraphel "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("Tamar,")]), _vm._v(" King Solomon’s older half-sister\n"), _c('br'), _vm._v("Tobiah, King Solomon’s servant "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("Yahalom,")]), _vm._v(" gem carver and seal ring merchant "), _c('br'), _vm._v("Zadok, the high priest of the Temple "), _c('br'), _vm._v("Zhurleen, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Queen Michal’s")]), _vm._v(" friend, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Queen Abishag’s")]), _vm._v(" mother, Princess Baalit’s grandmother")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-br"
  }, [_c('span', [_vm._v("SOME OF PRINCESS BAALIT’S OTHER "), _c('br'), _vm._v("HALF-BROTHERS (KING SOLOMON’S SONS "), _c('br'), _vm._v("BY VARIOUS WIVES AND CONCUBINES) "), _c('br'), _vm._v("Abner "), _c('br'), _vm._v("Caleb "), _c('br'), _vm._v("Eliakim "), _c('br'), _vm._v("Eliazar "), _c('br'), _vm._v("Ishbaal "), _c('br'), _vm._v("Jerioth "), _c('br'), _vm._v("Joab "), _c('br'), _vm._v("Jonathan "), _c('br'), _vm._v("Mesach "), _c('br'), _vm._v("Samuel "), _c('br'), _vm._v("Saul")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-br"
  }, [_c('span', [_vm._v("SOME OF KING SOLOMON’S OTHER "), _c('br'), _vm._v("WIVES AND CONCUBINES "), _c('br'), _vm._v("Aiysha "), _c('br'), _vm._v("Arinike "), _c('br'), _vm._v("Arishat "), _c('br'), _vm._v("Halit "), _c('br'), _vm._v("Jecoliah "), _c('br'), _vm._v("Marah "), _c('br'), _vm._v("Naomi "), _c('br'), _vm._v("Nilufer "), _c('br'), _vm._v("Paziah "), _c('br'), _vm._v("Rahab "), _c('br'), _vm._v("Ulbanu "), _c('br'), _vm._v("Xenodice "), _c('br'), _vm._v("Yeshara")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b83d060","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781466821378_fm04.vue
// module id = 69
// module chunks = 0